import Vue from 'vue';

// Sentry.io error tracking
import * as Sentry from "@sentry/vue";

// Styling libraries
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';

// Libs
import VueSweetalert2 from 'vue-sweetalert2';

// Store and Vuex
import Vuex from 'vuex';

// Routers
import VueRouter from 'vue-router';
import router from '@/router';

// Components
import BaseCard from './components/BaseCard';

// Services
import helpers from './services/helpers';
import api from './services/api';

import App from '@/App.vue';
import store from '@/store';

Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
Vue.use(VueRouter);
Vue.use(ElementUI, { locale });
Vue.component('base-card', BaseCard);

console.log('started');
console.log(process.env.VUE_APP_STAGE);

// Sentry error tracking
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  environment: process.env.VUE_APP_STAGE,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "https://labelswap-us-stage.herokuapp.com/api/", "https://labeltrader-us-prod.herokuapp.com/", "https://offers.labelswap.com/api/"],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Middleware for helpers
Vue.use({
  install() {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
    Vue.prototype.$api = api;
  }
});

if (localStorage.getItem('token')) {
  // Get & store shopper config
  helpers.getShopperConfig();
}

const vue = new Vue({
  router,
  store,
  components: { BaseCard },
  render: (h) => h(App)
});

vue.$mount('#app');
